import {createAction, props} from "@ngrx/store";
import {CreateWorkingGroupCommand, WorkingGroupDto, WorkingGroupPostDocumentDto} from "@esa/api";
import {WorkingGroupsStats} from "../../models/working-groups";
import {EnumDetailDto} from "@esa/api/models/EnumDetailDto";
import type {UpdateWorkingGroupCommand} from "@esa/api/models/UpdateWorkingGroupCommand";
import type {WorkingGroupDetailDto} from "@esa/api/models/WorkingGroupDetailDto";
import type {WorkingGroupStatusEnum} from "@esa/api/models/WorkingGroupStatusEnum";
import type {WorkingGroupPostDto} from "@esa/api/models/WorkingGroupPostDto";
import type {CreateWorkingGroupPostCommand} from "@esa/api/models/CreateWorkingGroupPostCommand";
import type {WorkingGroupRequestStatusEnum} from "@esa/api/models/WorkingGroupRequestStatusEnum";
import type {WorkingGroupRequestDto} from "@esa/api/models/WorkingGroupRequestDto";

export const getWorkingGroups = createAction(
  '[Working Groups] Get Working Groups',
  props<{ pageNumber: number, pageSize: number, groupStatus: WorkingGroupStatusEnum }>()
)

export const getWorkingGroupsSuccess = createAction(
  '[Working Groups] Get Working Groups Success',
  props<{ workingGroups: WorkingGroupDto[], workingGroupsStats: WorkingGroupsStats }>()
)

export const getWorkingGroupsError = createAction(
  '[Working Groups] Get Working Groups Error',
)

export const createWorkingGroup = createAction(
  '[Working Groups] Create Working Group',
  props<{ workingGroup: CreateWorkingGroupCommand }>()
)

export const createWorkingGroupSuccess = createAction(
  '[Working Groups] Create Working Group Success',
)
export const createWorkingGroupError = createAction(
  '[Working Groups] Create Working Group Error',
)

export const getWorkingGroupById = createAction(
  '[Working Groups] Get Working Group By ID',
  props<{ id: string }>()
)

export const getWorkingGroupByIdSuccess = createAction(
  '[Working Groups] Get Working Group By ID Success',
  props<{ selectedWorkingGroup: WorkingGroupDetailDto }>()
)

export const getWorkingGroupByIdError = createAction(
  '[Working Groups] Get Working Group By ID Error',
)

export const setSelectedWorkingGroupId = createAction(
  '[Working Groups] Set Selected Working Group Id',
  props<{ selectedWorkingGroupId: string }>()
)

export const setSelectedWorkingGroup = createAction(
  '[Working Groups] Set Selected Working Group',
  props<{ selectedWorkingGroup: WorkingGroupDetailDto }>()
)

export const getWorkingGroupTypes = createAction(
  '[Working Groups] Get Working Group Types',
)

export const getWorkingGroupTypesSuccess = createAction(
  '[Working Groups] Get Working Group Types Success',
  props<{ workingGroupTypes: EnumDetailDto[] }>()
)

export const getWorkingGroupTypesError = createAction(
  '[Working Groups] Get Working Group Types Error',
)

export const updateWorkingGroup = createAction(
  '[Working Groups] Update Working Group',
  props<{ workingGroup: UpdateWorkingGroupCommand }>()
)

export const updateWorkingGroupSuccess = createAction(
  '[Working Groups] Update Working Group Success',
)

export const updateWorkingGroupError = createAction(
  '[Working Groups] Update Working Group Error',
)

export const archiveWorkingGroup = createAction(
  '[Working Groups] Archive Working Group',
  props<{ id: string }>()
)

export const archiveWorkingGroupSuccess = createAction(
  '[Working Groups] Archive Working Group Success',
)

export const archiveWorkingGroupError = createAction(
  '[Working Groups] Archive Working Group Error',
)

export const unarchiveWorkingGroup = createAction(
  '[Working Groups] Unarchive Working Group',
  props<{ id: string }>()
)

export const unarchiveWorkingGroupSuccess = createAction(
  '[Working Groups] Unarchive Working Group Success',
)

export const unarchiveWorkingGroupError = createAction(
  '[Working Groups] Unarchive Working Group Error',
)

export const getSelectedWorkingGroupPosts = createAction(
  '[Working Groups] Get Selected Working Group Posts',
  props<{ id: string, search: string, pageNumber: number, pageSize: number }>()
)

export const getSelectedWorkingGroupPostsSuccess = createAction(
  '[Working Groups] Get Selected Working Group Posts Success',
  props<{ selectedWorkingGroupPosts: WorkingGroupPostDto[], selectedWorkingGroupPostsCount: number }>()
)

export const getSelectedWorkingGroupPostsError = createAction(
  '[Working Groups] Get Selected Working Group Posts Error',
)

export const createWorkingGroupPost = createAction(
  '[Working Groups] Create Working Group Post',
  props<{ post: CreateWorkingGroupPostCommand, pageNumber: number, pageSize: number }>()
)

export const createWorkingGroupPostSuccess = createAction(
  '[Working Groups] Create Working Group Post Success',
  props<{ post: CreateWorkingGroupPostCommand, pageNumber: number, pageSize: number }>()
)

export const createWorkingGroupPostError = createAction(
  '[Working Groups] Create Working Group Post Error',
)

export const createWorkingGroupRequest = createAction(
  '[Working Groups] Create Working Group Request',
  props<{ id: string, reason: string }>()
)

export const createWorkingGroupRequestSuccess = createAction(
  '[Working Groups] Create Working Group Request Success',
)

export const createWorkingGroupRequestError = createAction(
  '[Working Groups] Create Working Group Request Error',
)

export const getSelectedWorkingGroupRequests = createAction(
  '[Working Groups] Get Selected Working Group Requests',
  props<{ id: string, requestStatus: WorkingGroupRequestStatusEnum }>()
)

export const getSelectedWorkingGroupRequestsSuccess = createAction(
  '[Working Groups] Get Selected Working Group Requests Success',
  props<{ selectedWorkingGroupRequests: WorkingGroupRequestDto[] }>()
)

export const getSelectedWorkingGroupRequestsError = createAction(
  '[Working Groups] Get Selected Working Group Requests Error',
)

export const approveSelectedWorkingGroupRequest = createAction(
  '[Working Groups] Approve Selected Working Group Request',
  props<{ id: string, workingGroupId: string }>()
)

export const approveSelectedWorkingGroupRequestSuccess = createAction(
  '[Working Groups] Approve Selected Working Group Request Success',
  props<{ workingGroupId: string }>()
)

export const approveSelectedWorkingGroupRequestError = createAction(
  '[Working Groups] Approve Selected Working Group Request Error',
)

export const rejectSelectedWorkingGroupRequest = createAction(
  '[Working Groups] Reject Selected Working Group Request',
  props<{ id: string, reason: string, workingGroupId: string }>()
)

export const rejectSelectedWorkingGroupRequestSuccess = createAction(
  '[Working Groups] Reject Selected Working Group Request Success',
  props<{ workingGroupId: string }>()
)

export const rejectSelectedWorkingGroupRequestError = createAction(
  '[Working Groups] Reject Selected Working Group Request Error',
)

export const setSelectedWorkingGroupRequestId = createAction(
  '[Working Groups] Set Selected Working Group Request Id',
  props<{ selectedWorkingGroupRequestId: string }>()
)

export const approveSelectedWorkingGroup = createAction(
  '[Working Groups] Approve Selected Working Group',
  props<{ id: string }>()
)

export const approveSelectedWorkingGroupSuccess = createAction(
  '[Working Groups] Approve Selected Working Group Success',
)

export const approveSelectedWorkingGroupError = createAction(
  '[Working Groups] Approve Selected Working Group Error',
)

export const rejectSelectedWorkingGroup = createAction(
  '[Working Groups] Reject Selected Working Group',
  props<{ id: string, reason: string }>()
)

export const rejectSelectedWorkingGroupSuccess = createAction(
  '[Working Groups] Reject Selected Working Group Success',
)

export const rejectSelectedWorkingGroupError = createAction(
  '[Working Groups] Reject Selected Working Group Error',
)

export const assignGroupAdmin = createAction(
  '[Working Groups] Assign Group Admin',
  props<{ workingGroupId: string, userId: string, pageNumber: number, pageSize: number }>()
)

export const assignGroupAdminSuccess = createAction(
  '[Working Groups] Assign Group Admin Success',
  props<{ pageNumber: number, pageSize: number }>()
)

export const assignGroupAdminError = createAction(
  '[Working Groups] Assign Group Admin Error',
)

export const getWorkingGroupPostDocuments = createAction(
  '[Working Groups] Get Working Group Post Documents',
  props<{ workingGroupId: string, pageNumber: number, pageSize: number }>()
)

export const getWorkingGroupPostDocumentsSuccess = createAction(
  '[Working Groups] Get Working Group Post Documents Success',
  props<{ selectedWorkingGroupPostDocuments: WorkingGroupPostDocumentDto[], totalDocuments: number }>()
)

export const getWorkingGroupPostDocumentsError = createAction(
  '[Working Groups] Get Working Group Post Documents Error',
)
